import { render, staticRenderFns } from "./NewEditAulaPagePolivalencia.vue?vue&type=template&id=f0de0656&scoped=true"
import script from "./NewEditAulaPagePolivalencia.vue?vue&type=script&lang=js"
export * from "./NewEditAulaPagePolivalencia.vue?vue&type=script&lang=js"
import style0 from "./NewEditAulaPagePolivalencia.vue?vue&type=style&index=0&id=f0de0656&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0de0656",
  null
  
)

export default component.exports